import React, { useState, useContext } from 'react';
import Navbar from '../layouts/navbar';
import { AuthContext } from '../../auth';
import Parse from 'parse';
import swal from 'sweetalert';
import { Redirect } from 'react-router-dom';
import {Link} from 'react-router-dom';



const AddForum = () => {


    const [question, setQuestion] = useState('');
    const [submitted, setSubmitted] = useState('');
    const [description, setDescription] = useState('');
    const [logedinuser, setLogedinuser] = useContext(AuthContext);

    const handleSubmit = (event) => {
        event.preventDefault();
        const Forum = Parse.Object.extend('Forum');
        const forum = new Forum();

        forum.set("user_id", logedinuser);
        forum.set("replies", []);
        forum.set("question", question);
        forum.set("description", description);


        forum.save()
            .then((data) => {
                console.log(data);
                swal("Added!", "Your thoughts have been shared", "success");
                setQuestion("");
                setDescription("");
                setSubmitted(true);

                // this.props.history.push('/familystories/route');
            }).catch((error) => {
                console.log(error);
                swal("Oops!", "Seems like we couldn't add your story...Please try again in sometime", "error");


            })


    }

    return (
        <div>
            {console.log(logedinuser, "called")}
            {(logedinuser == null) &&(<div>
                {swal("Oops!", "Please login to add a question")}
            </div>) &&(
                 <Redirect to={{
                     pathname:'/login',
                     re:'/forum'
                    }}/>
            )}
            {submitted?<Redirect to="/forum"></Redirect>:null}
            <Navbar head="Forum"></Navbar>
            <div className="container" style={{ marginTop: "150px" }}>
                
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input type="text" className="form-control" id="question" value={question} onChange={e => setQuestion(e.target.value)} placeholder="Your question" required></input>
                    </div>
                    <div className="form-group">
                        <textarea className="form-control" id="description" rows="10" value={description} onChange={e => setDescription(e.target.value)} placeholder="Description" required></textarea>
                    </div>
                    <div className="form-row justify-content-center">
                        
                            <input
                                type="submit"
                                className="submit btn-primary center-block mt-4 mr-2" />
                                <Link to="/forum">
                            <input
                                type="button"
                                value="Dismiss"
                                className="submit btn-warning center-block mt-4" />
                                </Link>
                            
                    
                    </div>
                </form>
            </div>
        </div>
    )
}

export default AddForum;